<script>
import {dateToString} from "../../helpers/utils";
import PersonDetails from "@/components/persons/person-details";
import PersonInline from "@/components/persons/person-inline.vue";
import Person from "../../services/models/person";

/**
 * Nav-bar Component
 */
export default {
  computed: {
    Person() {
      return Person
    }
  },
  components: {
    PersonInline,
    PersonDetails
  },
  props: {
    resource: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      correspondence: this.resource,
      selectedPerson: null
    };
  },
  methods: {
    displayDate(date) {
      return dateToString(date);
    },
    detailPerson(v) {
      this.selectedPerson = v;
    }
  }
};
</script>

<template>
  <b-card no-body class="text-center">
    <b-card-body>

      <b-row>
        <b-col>
          <span v-if="correspondence.document_type" class="badge bg-info font-size-11 m-1 text-lowercase" role="button">
            {{ correspondence.document_type ? correspondence.document_type.name : '' }}
          </span>
          <span v-if="correspondence.letter_type" class="badge bg-success font-size-11 m-1 text-lowercase"
                role="button">
            {{ correspondence.letter_type ? correspondence.letter_type.name : '' }}
          </span>
          <span v-if="correspondence.typescript_manuscript" class="badge bg-primary font-size-11 m-1 text-lowercase"
                role="button">
            {{ $t('general.' + correspondence.typescript_manuscript) }}
          </span>
        </b-col>
      </b-row>

      <b-row class="mb-3">
        <b-col>
          <span
              v-if="correspondence.page_quantity"
              role="button"
              class="badge bg-secondary text-primary font-size-11 m-1"
          >
            {{ correspondence.page_quantity + ' page' + (correspondence.page_quantity > 1 ? 's' : '') }}
          </span>
        </b-col>
      </b-row>

      <b-row class="mb-3">
        <b-col>
          <h5 v-if="correspondence.author" v-b-modal.modal-person-detail
              @click="selectedPerson = correspondence.author" class="hover-cursor-pointer">
            {{ new Person(correspondence.author) }}
          </h5>
          <p class="text-muted">{{ correspondence.location_departure }}</p>
        </b-col>
        <b-col>
          <h5>{{ displayDate(correspondence.date) }}</h5>
          <i class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"></i>
        </b-col>
        <b-col>
          <h5 v-if="correspondence.recipient" v-b-modal.modal-person-detail
              @click="selectedPerson = correspondence.recipient" class="hover-cursor-pointer">
            {{ new Person(correspondence.recipient) }}
          </h5>
          <p class="text-muted">{{ correspondence.location_destination }}</p>
        </b-col>
      </b-row>

      <b-row class="mb-3" v-if="correspondence.persons">
        <b-col>
          <template v-for="(person, i) in correspondence.persons">
            <person-inline :value="person" :key="i" v-b-modal.modal-person-detail @click="detailPerson"></person-inline>
          </template>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <h5 class="font-size-15 mb-1">
            <span class="text-dark">{{ correspondence.subject }}</span>
          </h5>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <blockquote>
            {{ correspondence.comment }}
          </blockquote>
        </b-col>
      </b-row>

      <!--<b-button variant="light" class="btn-label" v-if="correspondence.attachment">
        <i class="bx bx-paperclip label-icon"></i> {{ correspondence.attachment }}
      </b-button>-->

    </b-card-body>

    <b-modal id="modal-person-detail" centered hide-footer
             size="xl"
             title-class="font-18"
             @hide="selectedPerson = null">
      <person-details v-if="selectedPerson" :person="selectedPerson"></person-details>
    </b-modal>
  </b-card>
</template>
